var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeakersImageBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 601,
    height: 257,
    viewBox: "0 0 601 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M589.7.2c-77.1 1.5-156.3 21.5-215.2 80a266.3 266.3 0 00-73.8 136.5 266.2 266.2 0 00-73.9-136.5C170.6 24.4 95.1 2 22.1.2L11.8 0H0v33.7a272.4 272.4 0 0079.2 193.1c52.3 52 152.7 78.2 221.3 78.6h.3c68.7-.4 169-26.6 221.3-78.6a272.5 272.5 0 0079-184.2V.2h-11.4zM93 208.2c.2 0 0 0 0 0z",
    fill: "#00234B"
  })));
}
export default SvgSpeakersImageBg;